import axios from 'axios';
import qs from 'qs';

export const getAdmins = (params: Record<string, any>) =>
  axios.get(`/api/v1/admins?${qs.stringify(params)}`);

export const getAdminById = (adminId: string) =>
  axios.get(`/api/v1/admins/${adminId}`);

export const updateAdminById = (adminId: string, data: any) =>
  axios.put(`/api/v1/admins/${adminId}`, data);

export const getCoursesByAdminId = (adminId: string) =>
  axios.get(`/api/v1/admins/${adminId}/courses`);

export const createAdmin = (data: any) => axios.post('/api/v1/admins', data);

export const importAdmins = ({
  data,
  config = {},
}: {
  data: any;
  config?: import('axios').AxiosRequestConfig;
}) =>
  axios.post('/api/v1/admins/import', data, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const finishImportAdmins = (data: any) =>
  axios.post('/api/v1/admins/import/finish', data);
